import React from 'react'
import { Lock, Star } from 'lucide-react'
import Image from 'next/image'
import Button from "../ui/Button";

interface UpgradeBannerProps {
  onUpgradeClick?: () => void
}

export const HorizontalUpgradeBanner = ({ onUpgradeClick }: UpgradeBannerProps = {}) => {
  const handleProClick = onUpgradeClick || (() => window.open('/pricing', '_blank'))
  return (
    <div className="bg-[#F3FAEB] rounded-xl py-4 sm:py-6 px-4 sm:px-6 w-full">
      <div className="flex flex-col lg:flex-row items-center justify-between gap-4 sm:gap-6">
        {/* Left Section - Text and Buttons */}
        <div className="flex-1 space-y-3 sm:space-y-4 w-full lg:w-auto">
          {/* Title */}
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 leading-tight sm:leading-relaxed">
            Upgrade to <span className="text-[#85C349]">Professional</span> for more features.
          </h2>
          
          {/* Description */}
          <p className="text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed">
            Discover the full potential of Culineer & elevate your experience like never before.
          </p>
          
          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <Button onClick={handleProClick} className="w-full sm:w-auto text-sm sm:text-base">
              Upgrade to Pro
            </Button>
            <Button
              onClick={handleProClick}
              className="w-full sm:w-auto text-sm sm:text-base border-2 border-[#85C349] bg-white hover:bg-white text-black hover:text-black"
            >
              See Benefits
            </Button>
          </div>
        </div>
        
        {/* Right Section - Static Image */}
        <div className="relative flex-shrink-0 w-full lg:w-auto">
          <div className="relative -mt-8 sm:-mt-12 lg:-mt-16 flex justify-center lg:justify-end">
            <Image
              src="/assets/images/lockstart.png"
              alt="Upgrade to professional features"
              width={300}
              height={300}
              className="w-48 sm:w-64 lg:w-80 h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export const VerticalUpgradeBanner = ({ onUpgradeClick }: UpgradeBannerProps = {}) => {
  const handleProClick = onUpgradeClick || (() => window.open('/pricing', '_blank'))

  return (
    <div className="bg-white rounded-xl text-center px-3 sm:px-4 py-4 sm:py-6">
      <div className="flex flex-col items-center space-y-3 sm:space-y-4">
        <div className="relative -mt-8 sm:-mt-10">
          <Image
            src="/assets/images/lockstart.png"
            alt="Upgrade to professional features"
            width={80}
            height={80}
            className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 object-contain"
          />
        </div>
        <div className="flex flex-col gap-2 sm:gap-3 items-center">
          <h2 className="text-xs sm:text-sm lg:text-base font-bold text-gray-900 leading-tight px-2">
            Upgrade to <span className="text-[#85C349]">Pro</span> for more features.
          </h2>
          <Button onClick={handleProClick} className="w-full text-xs sm:text-sm py-1.5 sm:py-2 px-2 sm:px-3">
            Upgrade
          </Button>
        </div>
      </div>
    </div>
  )
}